import { api } from "./api";

export const checarToken = (token) => {
    return api.get(`/ass/${token}`);
};
  
export const assinar = (token, body) => {
    return api.post(`/ass/assinar/${token}`, body)
}

export const atualizarToken = (body) => {
    return api.put("/ass/update", body)
}